

//------------------imports--------------
import * as React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CircularProgress from "@mui/material/CircularProgress";

import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { Measuringdata } from "../../assets/Griddata";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useState, useEffect } from "react";
import { externalgetApi } from "../../services/external/externalApis";
import { SETTINGS_API_26 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import {
  CON_STATUS_ACTIVE
} from "../../utils/sys/Constants";
import SearchAppBar from "../../components/common/search";
function ViewMeasuringUnit() {
  //------------------hooks------------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_26, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
   
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      MUCODE: item.MUCODE,
      MEASURINGUNITNAME: item.MEASURINGUNITNAME,
      MEASURINGUNIT: item.MEASURINGUNIT,
   
    }));
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        return (
          item.MEASURINGUNITNAME.toLowerCase().includes(searchText.toLowerCase()) ||
          item.MEASURINGUNIT.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  //----------------------functions--------------------------

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.MUCODE === id);
      if (selectedItem) {
        navigate(`/Measuringunit`, { state: { selectedItem, actionText } });
      }
    } else {
      navigate(`/Measuringunit`, { state: { selectedItem: "" } });
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (MUCODE) => handleItemClick(MUCODE, "Edit"),
    },
  ];

  const rows = filteredData ? mapResultToRows(filteredData) : [];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Setting</Link>
                <Link underline="none">View Measuring Units</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => handleItemClick()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={Measuringdata.columns}
          rows={rows.map((item) => ({ ...item, id: item.MUCODE }))}
          menuItems={menuItems}
          tabletitle={Measuringdata.name}
          gridid="MUCODE"
        />
      )}
    </div>
  );
}

export default ViewMeasuringUnit;
